import PolicyLayout from '../../components/PolicyLayout';

export default function PrivacyPage() {
  return (
    <PolicyLayout title="Privacy Policy" lastUpdated="February 2026">
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">1. Introduction</h2>
        <p className="text-slate-400">
          At StatioMart, we are committed to protecting your privacy. This Privacy Policy explains
          how we collect, use, and safeguard your information when you use StatioPrint services at
          www.statioprint.statiomart.com.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">2. Information We Collect</h2>
        <p className="text-slate-400 mb-4">We may collect the following information:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>
            <strong>Personal Information:</strong> Name, email address, phone number (if provided)
          </li>
          <li>
            <strong>Transaction Data:</strong> Payment information processed securely via Razorpay
          </li>
          <li>
            <strong>Document Data:</strong> Files uploaded for printing (automatically deleted after
            processing)
          </li>
          <li>
            <strong>Usage Data:</strong> Browser type, device information, and usage patterns
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">3. How We Use Your Information</h2>
        <p className="text-slate-400 mb-4">We use the collected information to:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>Process and fulfill your print orders</li>
          <li>Process payments securely</li>
          <li>Communicate with you about your orders</li>
          <li>Improve our services and user experience</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">4. Data Security</h2>
        <p className="text-slate-400 mb-4">
          We implement appropriate security measures to protect your information:
        </p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>All data is transmitted over secure HTTPS connections</li>
          <li>Payment processing is handled by Razorpay's PCI-DSS compliant systems</li>
          <li>Uploaded documents are automatically deleted after printing</li>
          <li>Access to personal data is restricted to authorized personnel only</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">5. Document Handling</h2>
        <p className="text-slate-400">
          Documents uploaded for printing are stored temporarily and are automatically deleted from
          our servers daily at midnight. We do not access, read, or share the contents of your
          documents except as necessary to fulfill your print request.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">6. Third-Party Services</h2>
        <p className="text-slate-400 mb-4">We use the following third-party services:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>
            <strong>Razorpay:</strong> For secure payment processing
          </li>
          <li>
            <strong>AWS:</strong> For secure document storage
          </li>
          <li>
            <strong>Google:</strong> For authentication services
          </li>
        </ul>
        <p className="text-slate-400 mt-4">
          These services have their own privacy policies governing the use of your information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">7. Your Rights</h2>
        <p className="text-slate-400 mb-4">You have the right to:</p>
        <ul className="list-disc pl-6 text-slate-400 space-y-2">
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Withdraw consent for data processing</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">8. Cookies</h2>
        <p className="text-slate-400">
          We use essential cookies to maintain your session and provide our services. We do not use
          tracking cookies for advertising purposes.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-4">9. Contact Us</h2>
        <p className="text-slate-400">
          For privacy related inquiries, please contact us at{' '}
          <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
            info@statiomart.com
          </a>
        </p>
      </section>
    </PolicyLayout>
  );
}
